import { yup } from '@framework/validation';
import { CiComputedBinaryGear } from '../../../../../ui/icons-custom/IconsCustom';
import { Datatype } from '../../../../expressions/datatype/Datatype';
import { getDynamicWidgetReference } from '../../../../expressions/references/builder/getDynamicWidgetReference';
import { tran } from '../../../../translations/schema/TranslationSchema';
import { IWidgetType } from '../../../IWidgetType';
import { WidgetCategory, WidgetMainType, WidgetType } from '../../../Widget';
import { createCommonFormSchema } from '../../inputs/common/createCommonFormSchema';
import { IComputedBooleanWidget } from '../IComputedWidget';
import { ComputedBooleanConfigComponent } from './ComputedBooleanConfigComponent';
import { ComputedBooleanWidgetComponent } from './ComputedBooleanWidgetComponent';
import { ComputedBooleanWidgetPreview } from './ComputedBooleanWidgetPreview';
import { computedBooleanConfigSchema } from './computedBooleanConfigSchema';
import { setComputedBooleanTransform } from './setComputedBooleanTransform';

export const ComputedBooleanWidgetType: IWidgetType<IComputedBooleanWidget> = {
  type: WidgetType.ComputedBoolean,
  mainType: WidgetMainType.Input,
  category: WidgetCategory.Computed,
  hasValue: true,
  getReference: getDynamicWidgetReference(Datatype.Boolean),
  name: 'Condizione Calcolata',
  icon: <CiComputedBinaryGear />,
  rules: [],
  formComponent: ComputedBooleanWidgetComponent,
  createFormSchema: ({ widget, parentScope }) => {
    return createCommonFormSchema(
      setComputedBooleanTransform(
        widget,
        parentScope,
        yup.boolean().notRequired(),
      ),
      widget,
    );
  },
  configComponent: ComputedBooleanConfigComponent,
  configValidator: computedBooleanConfigSchema,
  previewComponent: ComputedBooleanWidgetPreview,
  translationSchema: tran.widget({
    label: tran.rte(),
    text: tran.rte(),
  }),
  alwaysEnabled: true,
};
